// 検索機能関連のハンドラー

// 検索前の展開状態を保存
let preSearchCategoryState = new Map<string, boolean>();
let preSearchSectionState = new Map<string, boolean>();

/**
 * 検索機能
 */
export function filterSettings(searchTerm: string): void {
    const term = searchTerm.toLowerCase();
    const sections = document.querySelectorAll('.section-container');
    const categories = document.querySelectorAll('.category-container');
    
    // 検索開始時（検索欄が空から何か入力された時）に現在の状態を保存
    if (term !== '' && preSearchCategoryState.size === 0 && preSearchSectionState.size === 0) {
        document.querySelectorAll('.category-content').forEach(content => {
            if (content.id) {
                preSearchCategoryState.set(content.id, !content.classList.contains('hidden'));
            }
        });
        
        document.querySelectorAll('.section-content').forEach(content => {
            if (content.id) {
                preSearchSectionState.set(content.id, !content.classList.contains('hidden'));
            }
        });
    }
    
    // 検索終了時（検索欄が空になった時）に元の状態に戻す
    if (term === '') {
        preSearchCategoryState.forEach((wasOpen, categoryId) => {
            const content = document.getElementById(categoryId);
            if (content) {
                const arrow = content.previousElementSibling?.querySelector('.category-arrow');
                if (wasOpen) {
                    content.classList.remove('hidden');
                    arrow?.classList.add('rotate-180');
                } else {
                    content.classList.add('hidden');
                    arrow?.classList.remove('rotate-180');
                }
            }
        });
        
        preSearchSectionState.forEach((wasOpen, sectionId) => {
            const content = document.getElementById(sectionId);
            if (content) {
                const arrow = content.previousElementSibling?.querySelector('.section-arrow');
                if (wasOpen) {
                    content.classList.remove('hidden');
                    arrow?.classList.add('rotate-180');
                } else {
                    content.classList.add('hidden');
                    arrow?.classList.remove('rotate-180');
                }
            }
        });
        
        // 状態をクリア
        preSearchCategoryState.clear();
        preSearchSectionState.clear();
        
        // 全ての項目を表示
        sections.forEach(section => {
            (section as HTMLElement).style.display = 'block';
            const items = section.querySelectorAll('[id^="toggleContainer_"]');
            items.forEach(item => {
                (item as HTMLElement).style.display = '';
            });
        });
        
        return;
    }
    
    // 各カテゴリでマッチしたセクションがあるかチェック
    const categoryHasMatches = new Map();
    
    sections.forEach(section => {
        const items = section.querySelectorAll('[id^="toggleContainer_"]');
        let sectionVisible = false;
        
        items.forEach(item => {
            // NIC設定パネルなどの動的リストは検出
            const isDynamicList = item.querySelector('[id^="nicList_"]') !== null;
            const title = item.querySelector('h3')?.textContent?.toLowerCase() || '';
            const description = item.querySelector('p')?.textContent?.toLowerCase() || '';
            const matches = term === '' || title.includes(term) || description.includes(term);
            
            if (isDynamicList) {
                // 動的リストの場合は display: block を維持
                (item as HTMLElement).style.display = matches ? 'block' : 'none';
            } else {
                // 通常のトグル項目は display: flex
                (item as HTMLElement).style.display = matches ? 'flex' : 'none';
            }
            
            if (matches) sectionVisible = true;
        });
        
        // セクションの表示/非表示
        (section as HTMLElement).style.display = sectionVisible ? 'block' : 'none';
        
        // 検索中でマッチしたセクションは自動的に展開
        if (term !== '' && sectionVisible) {
            const content = section.querySelector('.section-content');
            const arrow = section.querySelector('.section-arrow');
            if (content && content.classList.contains('hidden')) {
                content.classList.remove('hidden');
                if (arrow) arrow.classList.add('rotate-180');
            }
            
            // 親カテゴリを特定してマッチフラグを設定
            const category = section.closest('.category-container');
            if (category) {
                categoryHasMatches.set(category, true);
            }
        }
    });
    
    // マッチしたセクションを含むカテゴリを自動的に展開
    if (term !== '') {
        categories.forEach(category => {
            if (categoryHasMatches.get(category)) {
                const content = category.querySelector('.category-content');
                const arrow = category.querySelector('.category-arrow');
                if (content && content.classList.contains('hidden')) {
                    content.classList.remove('hidden');
                    if (arrow) arrow.classList.add('rotate-180');
                }
            }
        });
    }
}

